import clsx from 'clsx';
import React from 'react';

import AvatarList from '@/src/components/common/Avatar/List/List';
import { DEFAULT_NULL_VALUE } from '@/src/components/project/Inbox2/Config/inbox.config';

type AccessListProps = {
  items;
  itemId?;
};

const AccessList = ({ items, itemId }: AccessListProps) => {
  if (items.length < 1) {
    return <span>{DEFAULT_NULL_VALUE}</span>;
  }
  return (
    <AvatarList
      id={itemId}
      className={clsx('tw-ml-[-10px]')}
      avatars={items}
      renderer={(m) => `${m.firstName} ${m.lastName}`}
    />
  );
};

export default AccessList;
